<template>
  <div id="registerContainer">
    <div class="columns">
      <div class="column"/>
      <div class="column is-half">

        <div class="card">
          <header class="card-header">
            <p class="card-header-title">
              Register
            </p>
          </header>
          <div class="card-content">
            <form @submit.prevent="register">
              <b-field label="Passcode">
                <b-input
                  v-model="passcode"
                  type="password"
                  icon="user-secret"
                  icon-pack="fa"
                  placeholder="Please contact administrator for the passcode" />
              </b-field>
              <b-field label="Username">
                <b-input
                  v-model="username"
                  icon="user"
                  icon-pack="fa" />
              </b-field>
              <b-field label="Password">
                <b-input
                  v-model="password"
                  type="password"
                  icon="key"
                  icon-pack="fa" />
              </b-field>
              <b-field label="Email">
                <b-input
                  v-model="email"
                  icon="at"
                  icon-pack="fa" />
              </b-field>
              <b-field label="Full Name">
                <b-input
                  v-model="fullName"
                  icon="address-card"
                  icon-pack="fa" />
              </b-field>

              <div class="field is-grouped">
                <div class="control">
                  <button
                    :class="'button is-link ' + submitButtonClasses"
                    type="submit">Register</button>
                </div>
              </div>
            </form>

          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <span>
                If you have trouble, please contact administrator.
              </span>
            </p>
          </footer>
        </div>
      </div>
      <div class="column"/>
    </div>
  </div>
</template>

<script>
import { register } from '../utils/auth'

export default {
  name: 'login',
  data() {
    return {
      passcode: '',
      username: '',
      password: '',
      email: '',
      fullName: '',
      submitButtonClasses: ''
    }
  },
  methods: {
    register: function() {
      if (this.passcode === '' || this.username === '' || this.password === '' || this.email === '' || this.fullName === '') {
        this.$toast.open({
          message: 'Please fill out all the fields.',
          duration: 3000,
          position: 'is-top',
          type: 'is-danger'
        })
        return
      }
      let self = this
      self.submitButtonClasses = 'is-loading'
      register(
        this.passcode,
        this.username,
        this.password,
        this.email,
        this.fullName)
        .then(function(data) {
          self.$toast.open({
            message: 'Registration successful. Please log in with your username and password.',
            duration: 5000,
            position: 'is-top',
            type: 'is-success'
          })
          self.$router.push('/login')
        })
        .catch(function(err) {
          console.log(err)
          self.passcode = self.username = self.password = self.email = self.fullName = ''
          self.$toast.open({
            message: 'Registration failed. Please contact administrator.',
            duration: 3000,
            position: 'is-top',
            type: 'is-danger'
          })
        })
        .finally(function() {
          self.submitButtonClasses = ''
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#registerContainer {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue